import { ThunkAction } from "redux-thunk";
import {
    API_OFFLINE_APP,
    apiLoad,
    dismissMessage,
    pushMessage,
    setApiError,
    STAMP_BEGIN,
    timeout,
    TIMEOUT,
} from "../../shared/timeclock/actions";
import { ErrorMessages } from "../messages";
import { timeClockAuthenticatePost } from "../../shared/timeplan-api-client";

export function reload(): ThunkAction<Promise<void>, unknown, void> {
    return async (dispatch) => {
        dispatch(apiLoad());
        try {
            const json = await timeout(TIMEOUT, timeClockAuthenticatePost({}));

            dispatch({
                messages: [],
                stampPerson: json.authenticatedPerson,
                type: STAMP_BEGIN,
            });
        } catch (error) {
            if (error.jsonError) dispatch(setApiError("AuthenticationErrors", error));
            else {
                dispatch({ type: API_OFFLINE_APP });
                dispatch(pushMessage({ systemMessage: ErrorMessages.GenericError }));
                setTimeout(() => {
                    dispatch(dismissMessage());
                }, 1000);
            }
        }
    };
}
